import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const crossref = new Restful(project, 'crossref')

// 原文章注册doi接口,现重置
crossref.doi = function(data) {
  const url = project + 'crossref/doi'
  return http.get(url, data).then(res => {
    return res
  })
}

crossref.articalDoi = function(data) {
  const url = project + 'crossref/doi/article'
  return http.get(url, data).then(res => {
    return res
  })
}
crossref.articalDoiOffline = function(data) {
  const url = project + 'crossref/doi/article/offline'
  return http.get(url, data).then(res => {
    return res
  })
}
// doi重置
crossref.resetDoi = function(data) {
  const url = project + 'crossref/doi/article/reset'

  return http.get(url, data).then(res => {
    return res
  })
}
crossref.issueDoi = function(data) {
  const url = project + 'crossref/doi/issue'
  return http.get(url, data).then(res => {
    return res
  })
}
crossref.doiCount = function(data) {
  const url = project + 'crossref/count'
  return http.get(url, data).then(res => {
    return res
  })
}

export default crossref
